<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sradio/SradioPreview'
export default {
  name: 'SSexPreview',
  extends: compoment
}
</script>
